import React, { useState } from 'react';
import {
    Users,
    FileText,
    ShieldAlert,
    Check,
    X,
    Eye,
    MessageSquare,
    Lock
} from 'lucide-react';

const AdminView = () => {
    const [activeQueue, setActiveQueue] = useState('kyc');

    const pendingKYC = [
        { id: 1, name: 'Adekunle Gold', type: 'Private Tutor', date: '2026-02-18', documents: ['ID Card', 'B.Sc Certificate'] },
        { id: 2, name: 'Zainab Musa', type: 'Domestic Worker', date: '2026-02-17', documents: ['ID Card', 'ND Certificate', 'Selfie'] },
        { id: 3, name: 'Dr. Ifeanyi Peter', type: 'Telemedicine', date: '2026-02-18', documents: ['Medical License', 'ID Card'] },
    ];

    const pendingSecurity = [
        { id: 4, name: 'Janet Moses', type: 'Domestic Worker', verification: 'Background Check', status: 'Processing' },
        { id: 5, name: 'Ruth Abraham', type: 'Domestic Worker', verification: 'Reference Contact', status: 'Pending Call' },
    ];

    return (
        <div className="admin-view animate-fade">
            <div className="admin-hero">
                <Lock size={24} color="var(--primary-green)" />
                <h2>Admin Review Console</h2>
                <p>Manage provider KYC, Security checks & Content moderation.</p>
            </div>

            <div className="admin-stats">
                <div className="stat-card">
                    <span className="count">12</span>
                    <span className="label">Pending KYC</span>
                </div>
                <div className="stat-card">
                    <span className="count">5</span>
                    <span className="label">Security Reviews</span>
                </div>
                <div className="stat-card">
                    <span className="count">8</span>
                    <span className="label">Reported Posts</span>
                </div>
            </div>

            <div className="queue-nav">
                <button className={activeQueue === 'kyc' ? 'active' : ''} onClick={() => setActiveQueue('kyc')}>KYC Queue</button>
                <button className={activeQueue === 'security' ? 'active' : ''} onClick={() => setActiveQueue('security')}>Security Reviews</button>
                <button className={activeQueue === 'moderation' ? 'active' : ''} onClick={() => setActiveQueue('moderation')}>Moderation</button>
            </div>

            <div className="queue-content">
                {activeQueue === 'kyc' && (
                    <div className="kyc-list">
                        {pendingKYC.map(item => (
                            <div key={item.id} className="review-card card">
                                <div className="review-info">
                                    <div className="review-meta">
                                        <h4>{item.name}</h4>
                                        <span className="role-tag">{item.type}</span>
                                    </div>
                                    <p className="doc-list">Docs: {item.documents.join(', ')}</p>
                                    <p className="date">Applied: {item.date}</p>
                                </div>
                                <div className="review-actions">
                                    <button className="view-btn"><Eye size={18} /></button>
                                    <button className="approve-btn"><Check size={18} /></button>
                                    <button className="reject-btn"><X size={18} /></button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {activeQueue === 'security' && (
                    <div className="security-list">
                        {pendingSecurity.map(item => (
                            <div key={item.id} className="review-card card">
                                <div className="review-info">
                                    <h4>{item.name}</h4>
                                    <p className="sec-type">{item.verification}</p>
                                    <span className={`status-pill ${item.status.toLowerCase().replace(' ', '-')}`}>{item.status}</span>
                                </div>
                                <div className="review-actions">
                                    <button className="primary-btn sm">Start Review</button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {activeQueue === 'moderation' && (
                    <div className="empty-state">
                        <MessageSquare size={48} color="var(--border-gray)" />
                        <p>No moments flagged for review.</p>
                    </div>
                )}
            </div>

            <div className="admin-footer" style={{ marginTop: '40px', padding: '20px', borderTop: '1px solid var(--border-gray)', background: '#F9FAFB', borderRadius: '12px' }}>
                <h3 style={{ fontSize: '14px', fontWeight: '800', marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <ShieldAlert size={16} color="var(--primary-green)" />
                    System Health & Monitoring
                </h3>
                <p style={{ fontSize: '12px', color: 'var(--text-light)', marginBottom: '16px' }}>
                    Verify that your Sentry SDK is capturing errors and session replays correctly.
                </p>
                <div style={{ display: 'flex', gap: '12px' }}>
                    <button 
                        className="secondary-btn sm" 
                        onClick={() => {
                            console.log("Triggering Sentry test error...");
                            throw new Error("EZ Naija Sentry Test: Admin Manual Trigger");
                        }}
                        style={{ border: '1px solid var(--emergency-red)', color: 'var(--emergency-red)', background: 'white' }}
                    >
                        Trigger Test Error
                    </button>
                </div>
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
        .admin-hero { text-align: center; margin-bottom: 24px; padding: 20px 0; }
        .admin-hero h2 { font-size: 22px; margin-top: 8px; }
        .admin-hero p { font-size: 14px; color: var(--text-light); }

        .admin-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-bottom: 30px; }
        .stat-card { background: var(--card-gray); padding: 16px 8px; border-radius: 12px; text-align: center; border: 1px solid var(--border-gray); }
        .stat-card .count { display: block; font-size: 20px; font-weight: 800; color: var(--primary-green); }
        .stat-card .label { font-size: 10px; font-weight: 700; color: var(--text-light); text-transform: uppercase; }

        .queue-nav { display: flex; gap: 8px; margin-bottom: 20px; }
        .queue-nav button { flex: 1; padding: 10px; font-size: 12px; font-weight: 700; border-radius: 8px; background: white; border: 1px solid var(--border-gray); color: var(--text-light); }
        .queue-nav button.active { background: var(--primary-green); color: white; border-color: var(--primary-green); }

        .review-card { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
        .review-meta { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; }
        .role-tag { font-size: 10px; background: var(--light-green); color: var(--primary-green); padding: 2px 6px; border-radius: 4px; font-weight: 700; }
        .doc-list { font-size: 12px; color: var(--text-light); margin-bottom: 2px; }
        .date { font-size: 11px; color: var(--text-light); opacity: 0.7; }

        .review-actions { display: flex; gap: 8px; }
        .view-btn, .approve-btn, .reject-btn { width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }
        .view-btn { background: var(--card-gray); color: var(--text-dark); }
        .approve-btn { background: var(--light-green); color: var(--primary-green); }
        .reject-btn { background: #fee2e2; color: var(--emergency-red); }

        .status-pill { font-size: 10px; padding: 2px 8px; border-radius: 10px; font-weight: 700; }
        .status-pill.processing { background: #fff7ed; color: #9a3412; }
        .status-pill.pending-call { background: #eff6ff; color: #1e40af; }

        .empty-state { text-align: center; padding: 40px 0; color: var(--text-light); font-size: 14px; }
      `}} />
        </div>
    );
};

export default AdminView;
